import { SxProps } from '@mui/system';

export const root: SxProps = {
  marginBottom: '8px',
  paddingTop: '4px',
};
